import { Star, Wine, ShieldCheck, Award } from 'lucide-react';

const TrustBadges = () => (
  <section data-testid="trust-badges" className="bg-gradient-to-r from-[#0f1729] to-[#1a1a2e] py-6 border-y border-white/5">
    <div className="max-w-6xl mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
      <div className="flex flex-col items-center gap-1.5">
        <Star className="w-6 h-6 text-amber-400" />
        <span className="text-white text-xs font-semibold">5-Star Google Reviews</span>
        <span className="text-gray-400 text-[10px]">Rated by visitors</span>
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <Wine className="w-6 h-6 text-green-400" />
        <span className="text-white text-xs font-semibold">Walk-in Tastings</span>
        <span className="text-gray-400 text-[10px]">From €14, Marina Rubicon</span>
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <ShieldCheck className="w-6 h-6 text-blue-400" />
        <span className="text-white text-xs font-semibold">800+ Products</span>
        <span className="text-gray-400 text-[10px]">Chosen by our team</span>
      </div>
      <div className="flex flex-col items-center gap-1.5">
        <Award className="w-6 h-6 text-purple-400" />
        <span className="text-white text-xs font-semibold">Family Business</span>
        <span className="text-gray-400 text-[10px]">Family-run since 2024</span>
      </div>
    </div>
  </section>
);

export default TrustBadges;
